import { Box } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";

import type { IMotionContainerProps } from "./types";

const varWrapEnterVariant = { animate: { transition: { staggerChildren: 0.1 } } };

const MotionContainer: React.FC<React.PropsWithChildren<IMotionContainerProps>> = ({ open, children, ...other }) => (
  <Box
    component={motion.div}
    animate={open ? "animate" : "exit"}
    variants={varWrapEnterVariant}
    {...other}
  >
    {children}
  </Box>
);

export default MotionContainer;
